import { useState, useEffect } from "react";
import { api } from "../../api/api";

const formatarCPF = (cpf) => {
  if (!cpf) return "";
  return cpf
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

const ClienteAutocomplete = ({ onSelect }) => {

  const [busca, setBusca] = useState("");
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selecionado, setSelecionado] = useState(null);

  useEffect(() => {

    let ativo = true;

    const delay = setTimeout(async () => {

      if (selecionado) return;

      if (!busca || busca.length < 3) {
        setResultados([]);
        return;
      }

      try {
        setLoading(true);

        const res = await api.get("/clientes/buscar", {
          params: { busca }
        });

        if (ativo) setResultados(res.data);

      } catch (err) {
        console.error(err);
      } finally {
        if (ativo) setLoading(false);
      }

    }, 500);

    return () => {
      ativo = false;
      clearTimeout(delay);
    };

  }, [busca, selecionado]);

  const handleSelect = (cliente) => {
    setSelecionado(cliente);
    setBusca(cliente.nomeCliente);
    setResultados([]);
    onSelect(cliente);
  };

  const limpar = () => {
    setSelecionado(null);
    setBusca("");
    setResultados([]);
    onSelect(null);
  };

  return (
    <div className="autocomplete-container">

      <input
        className="input autocomplete-input"
        placeholder="Digite nome ou CPF..."
        value={busca}
        onChange={(e) => {
          setSelecionado(null);
          setBusca(e.target.value);
        }}
      />

      {selecionado && (
        <button
          type="button"
          className="btn-clear"
          onClick={limpar}
        >
          ✕
        </button>
      )}

      {loading && (
        <div className="loading">Buscando...</div>
      )}

      {resultados.length > 0 && (
        <ul className="autocomplete-list">

          {resultados.map((c) => (
            <li
              key={c._id}
              className="autocomplete-item"
              onClick={() => handleSelect(c)}
            >
              <div className="cliente-nome">
                {c.nomeCliente}
              </div>

              <div className="cliente-cpf">
                CPF: {formatarCPF(c.cpf)}
              </div>
            </li>
          ))}

        </ul>
      )}

      {/* 🔥 CORREÇÃO: não mostra texto fantasma */}
      {!loading &&
        !selecionado &&
        busca.length >= 3 &&
        resultados.length === 0 && (
          <div className="no-results">
            Nenhum cliente encontrado
          </div>
      )}

    </div>
  );
};

export default ClienteAutocomplete;